import { IconButton as UiIconButton, styled, styledForMobile } from "@l2r-front/l2r-ui"

const BUTTON_SIZE = 36
const MOBILE_BUTTON_SIZE = 44

export const IconButton = styledForMobile(UiIconButton)(({ isMobile, theme }) => {
    const size = isMobile ? MOBILE_BUTTON_SIZE : BUTTON_SIZE

    return ({
        backgroundColor: theme.palette["colors/gris/100"].main,
        width: `${size}px !important`,
        height: size,

        "&:hover": {
            backgroundColor: theme.palette["colors/gris/150"].main,
        },
    })
})

export const CloseIconButton = styled(IconButton)({
    width: "fit-content",
})